<template>
  <section id="home">
    <Navbar />
    <Hero />
    <section id="best-foods" class="container my-3">
      <div class="title-section">
        <h3>Best <strong>Foods</strong></h3>
      </div>
      <div class="card-product-wrapper row">
        <div
          class="col-sm-6 col-md-4 my-3"
          v-for="product in products"
          :key="product.id"
        >
          <CardProduct :product="product" />
        </div>
      </div>
      <div class="text-center mt-md-5 mt-sm-3">
        <router-link class="btn btn-xs btn-success" to="/foods">
          <b-icon-search></b-icon-search>
          Lihat Semua
        </router-link>
      </div>
    </section>
  </section>
</template>

<script>
import axios from "axios";
import { API_URL } from "../utils/constant";

import Navbar from "../components/Navbar.vue";
import Hero from "../components/Hero.vue";
import CardProduct from "../components/CardProduct.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    Hero,
    CardProduct,
  },
  data() {
    return {
      products: "",
    };
  },
  methods: {
    setProduct(data) {
      this.products = data;
    },
  },
  mounted() {
    // Get Best Product
    axios
      .get(API_URL + "/best-products")
      .then((res) => {
        console.log(`get best foods:`, res.data);
        this.setProduct(res.data);
      })
      .catch((err) => {
        console.log("failed get best product :", err);
      });
  },
};
</script>
